import service from '@/utils/request'; // postDownloadUserNewUserInfo 新用户数据
// @Tags UserInfo
// @Summary 新用户数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "新用户数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postDownloadUserNewUserInfo = function postDownloadUserNewUserInfo(data) {
  return service({
    url: 'download/user/getNewUserInfo',
    method: 'post',
    data: data
  });
}; // getDownloadCenterList 任务中心列表获取
// @Tags UserInfo
// @Summary 任务中心列表获取
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "任务中心列表获取"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getDownloadCenterList = function getDownloadCenterList(params) {
  return service({
    url: 'download/center/getList',
    method: 'get',
    params: params
  });
}; // getShiftInfoList 获取班次信息
// @Tags UserInfo
// @Summary 获取班次信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "获取班次信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getShiftInfoList = function getShiftInfoList(params) {
  return service({
    url: 'shift/info/getList',
    method: 'get',
    params: params
  });
}; // postDownloadShopStockHistory 进销统计数据
// @Tags UserInfo
// @Summary 进销统计数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "进销统计数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postDownloadShopStockHistory = function postDownloadShopStockHistory(data) {
  return service({
    url: 'download/shop/stock/history',
    method: 'post',
    data: data
  });
}; // postDownloadCenterDelete 任务中心列表删除
// @Tags UserInfo
// @Summary 任务中心列表删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "任务中心列表删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postDownloadCenterDelete = function postDownloadCenterDelete(data) {
  return service({
    url: 'download/center/delete',
    method: 'post',
    data: data
  });
}; // postDownloadUserNewSvcInfo 新开卡接口
// @Tags UserInfo
// @Summary 新开卡接口
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "新开卡接口"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postDownloadUserNewSvcInfo = function postDownloadUserNewSvcInfo(data) {
  return service({
    url: 'download/user/getNewSvcInfo',
    method: 'post',
    data: data
  });
}; // postDownloadUserLostUserInfo 流失数据
// @Tags UserInfo
// @Summary 流失数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "流失数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postDownloadUserLostUserInfo = function postDownloadUserLostUserInfo(data) {
  return service({
    url: 'download/user/lostUserInfo',
    method: 'post',
    data: data
  });
}; // getDownloadSql sql下载列表
// @Tags Download
// @Summary sql下载列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "sql下载列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /download/task/rule/getList [get]

export var getDownloadSql = function getDownloadSql(params) {
  return service({
    url: '/download/task/rule/getList',
    method: 'get',
    params: params
  });
}; // downloadSql sql报表下载
// @Tags Download
// @Summary sql报表下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "sql报表下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /download/task/rule/godown [post]

export var downloadSql = function downloadSql(data) {
  return service({
    url: '/download/task/rule/godown',
    method: 'post',
    data: data
  });
};